import { PolicyPageLayout } from "./PolicyPageLayout";

export const EnvironmentPolicyPage = () => {
  return (
    <PolicyPageLayout
      eyebrow="Arihant Infracon"
      title="Environment Policy"
      sections={[
        {
          title: "Policy Statement",
          body: [
            "Arihant Infracon is committed to protecting the environment and minimizing the environmental impact of its construction and infrastructure activities. Environmental responsibility is embedded in our planning, execution and operational practices.",
          ],
        },
        {
          title: "Environmental Objectives",
          bullets: [
            "Comply with all applicable environmental laws and regulations.",
            "Prevent pollution and minimize environmental impact.",
            "Promote efficient use of resources.",
            "Reduce waste generation and enhance recycling.",
          ],
        },
        {
          title: "Environmental Management System",
          body: [
            "Our Environmental Management System is aligned with ISO 14001:2015 and includes:",
          ],
          bullets: [
            "Identification of environmental aspects and impacts.",
            "Environmental risk assessment and controls.",
            "Monitoring of emissions, waste and resource usage.",
          ],
        },
        {
          title: "Resource Management",
          body: ["We strive to optimize:"],
          bullets: [
            "Energy consumption.",
            "Water usage.",
            "Material efficiency through planning, monitoring and adoption of best practices.",
          ],
        },
        {
          title: "Waste Management",
          body: [
            "We implement structured waste management practices, including:",
          ],
          bullets: [
            "Segregation of waste at source.",
            "Safe handling and disposal of hazardous waste.",
            "Recycling and reuse wherever feasible.",
          ],
        },
        {
          title: "Pollution Prevention",
          body: ["Measures are implemented to control:"],
          bullets: [
            "Dust and noise emissions.",
            "Water contamination.",
            "Air pollution from construction activities.",
          ],
        },
        {
          title: "Awareness & Training",
          body: ["Employees and contractors are sensitized through:"],
          bullets: [
            "Environmental awareness programs.",
            "Site-specific environmental instructions.",
            "Continuous monitoring and reporting.",
          ],
        },
        {
          title: "Continual Improvement",
          body: [
            "Environmental performance is periodically reviewed to identify improvement opportunities and enhance sustainability outcomes.",
          ],
        },
        {
          title: "Management Commitment",
          body: [
            "Top management is committed to providing leadership and resources to ensure environmental protection and continual improvement.",
          ],
        },
      ]}
    />
  );
};
